import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { campaignData } from '../../../redux/landing/selectors';
import CertificateCard from './CertificateCard';

const selector = createStructuredSelector({ campaignData });

export default connect(selector, null)(CertificateCard);
